
































import {
  faChartLine,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    withoutLandingLink: { type: Boolean, default: false }
  },
  setup() {
    return {
      faChartLine,
      faQuestionCircle
    }
  }
})
